import { useState, useEffect } from 'react';
import { signOut, getIdToken } from 'firebase/auth';
import { auth } from './firebaseClient';

const BACKEND = 'https://3amenu.com/api';
const SITE_URL = 'https://3amenu.com';

function SuperAdmin({ kullanici }) {
  const [kullanicilar, setKullanicilar] = useState([]);
  const [yeniEmail, setYeniEmail] = useState('');
  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniPlan, setYeniPlan] = useState('standart');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [kafeDetaylar, setKafeDetaylar] = useState({});
  const [aramaMetni, setAramaMetni] = useState('');
  const [sifreGoster, setSifreGoster] = useState(false);
  const [abonelikModal, setAbonelikModal] = useState(null);
  const [abonelikTarih, setAbonelikTarih] = useState('');
  const [kontrolSonuc, setKontrolSonuc] = useState(null);
  const [aktifSekme, setAktifSekme] = useState('dashboard');
  const [kafeCirolar, setKafeCirolar] = useState({});
  const [cirolarYukleniyor, setCirolarYukleniyor] = useState(false);
  const [ciroPeriod, setCiroPeriod] = useState('bugun');

  const tokenAl = async () => await getIdToken(kullanici);

  const kullanicilariGetir = async () => {
    try {
      const token = await tokenAl();
      const res = await fetch(`${BACKEND}/admin/kullanicilar`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      const liste = Array.isArray(data) ? data : [];
      setKullanicilar(liste);
      const detaylar = {};
      liste.forEach(u => {
        detaylar[u.uid] = { plan: u.plan || 'standart', aktif: u.aktif !== false, abonelikBitis: u.abonelikBitis || null };
      });
      await Promise.all(liste.map(async (u) => {
        try {
          const kafe = await fetch(`${BACKEND}/menu/kafe-by-id/${u.uid}`).then(r => r.json());
          if (kafe) detaylar[u.uid] = { ...detaylar[u.uid], ...kafe };
        } catch {}
      }));
      setKafeDetaylar(detaylar);
    } catch (err) { console.error(err); }
  };

  const cirolariGetir = async () => {
    setCirolarYukleniyor(true);
    const bugun = new Date().toISOString().split('T')[0];
    let baslangic = bugun;
    if (ciroPeriod === 'hafta') {
      const d = new Date(); d.setDate(d.getDate() - 6);
      baslangic = d.toISOString().split('T')[0];
    } else if (ciroPeriod === 'ay') {
      const d = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      baslangic = d.toISOString().split('T')[0];
    }

    const yeniCirolar = {};
    await Promise.all(kullanicilar.map(async (u) => {
      try {
        const res = await fetch(`${BACKEND}/siparisler/rapor-detay/${u.uid}?baslangic=${baslangic}&bitis=${bugun}`).then(r => r.json());
        yeniCirolar[u.uid] = { toplam: res.genelToplam || 0, siparisSayisi: res.toplamSiparis || 0 };
      } catch { yeniCirolar[u.uid] = { toplam: 0, siparisSayisi: 0 }; }
    }));
    setKafeCirolar(yeniCirolar);
    setCirolarYukleniyor(false);
  };

  useEffect(() => { kullanicilariGetir(); }, []);
  useEffect(() => { if (kullanicilar.length > 0 && aktifSekme === 'dashboard') cirolariGetir(); }, [kullanicilar, ciroPeriod, aktifSekme]);

  const yeniKullaniciolustur = async () => {
    if (!yeniEmail.trim() || !yeniSifre.trim()) { alert('Email ve şifre boş olamaz!'); return; }
    setYukleniyor(true);
    try {
      const token = await tokenAl();
      const res = await fetch(`${BACKEND}/admin/kullanici`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ email: yeniEmail, sifre: yeniSifre }),
      });
      const data = await res.json();
      if (data.uid) {
        await fetch(`${BACKEND}/admin/kullanici-plan`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ uid: data.uid, plan: yeniPlan }),
        });
        await fetch(`${BACKEND}/admin/kullanici-aktif`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ uid: data.uid, aktif: true }),
        });
        alert(`✅ Hesap oluşturuldu!\nEmail: ${yeniEmail}\nŞifre: ${yeniSifre}\nPlan: ${yeniPlan}`);
        setYeniEmail(''); setYeniSifre(''); setYeniPlan('standart');
        kullanicilariGetir();
      } else { alert('Hata: ' + JSON.stringify(data)); }
    } catch (err) { alert('Hata: ' + err.message); }
    setYukleniyor(false);
  };

  const planGuncelle = async (uid, yeniPlanDegeri) => {
    try {
      const token = await tokenAl();
      await fetch(`${BACKEND}/admin/kullanici-plan`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ uid, plan: yeniPlanDegeri }),
      });
      kullanicilariGetir();
    } catch { alert('Hata!'); }
  };

  const aktifToggle = async (uid, mevcutDurum) => {
    const yeniDurum = !mevcutDurum;
    if (!window.confirm(yeniDurum ? 'Aktif edilsin mi?' : 'Pasife alınsın mı?')) return;
    try {
      const token = await tokenAl();
      await fetch(`${BACKEND}/admin/kullanici-aktif`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ uid, aktif: yeniDurum }),
      });
      kullanicilariGetir();
    } catch { alert('Hata!'); }
  };

  const abonelikKaydet = async () => {
    if (!abonelikTarih) { alert('Lütfen tarih seçin'); return; }
    try {
      const token = await tokenAl();
      await fetch(`${BACKEND}/admin/kullanici-abonelik`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ uid: abonelikModal.uid, abonelikBitis: abonelikTarih }),
      });
      await fetch(`${BACKEND}/admin/kullanici-aktif`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ uid: abonelikModal.uid, aktif: true }),
      });
      setAbonelikModal(null); setAbonelikTarih('');
      kullanicilariGetir();
      alert('✅ Abonelik kaydedildi!');
    } catch { alert('Hata!'); }
  };

  const abonelikKontrolEt = async () => {
    try {
      const token = await tokenAl();
      const res = await fetch(`${BACKEND}/admin/abonelik-kontrol`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setKontrolSonuc(data);
      kullanicilariGetir();
    } catch { alert('Hata!'); }
  };

  const kullaniciyiSil = async (uid) => {
    if (!window.confirm('Bu kullanıcıyı silmek istediğinize emin misiniz?')) return;
    try {
      const token = await tokenAl();
      await fetch(`${BACKEND}/admin/kullanici/${uid}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      kullanicilariGetir();
    } catch { alert('Hata!'); }
  };

  const abonelikDurumu = (uid) => {
    const kafe = kafeDetaylar[uid];
    if (!kafe?.abonelikBitis) return null;
    const bugun = new Date().toISOString().split('T')[0];
    const kalan = Math.ceil((new Date(kafe.abonelikBitis) - new Date(bugun)) / (1000 * 60 * 60 * 24));
    if (kalan < 0) return { durum: 'dolmus', kalan: 0, renk: '#ef4444', label: 'Süresi doldu' };
    if (kalan <= 7) return { durum: 'kritik', kalan, renk: '#f97316', label: `${kalan} gün kaldı` };
    if (kalan <= 30) return { durum: 'yakin', kalan, renk: '#eab308', label: `${kalan} gün kaldı` };
    return { durum: 'iyi', kalan, renk: '#22c55e', label: `${kalan} gün kaldı` };
  };

  const filtrelenmisKullanicilar = kullanicilar.filter(u => {
    const kafe = kafeDetaylar[u.uid];
    return `${u.email} ${kafe?.ad || ''} ${kafe?.slug || ''}`.toLowerCase().includes(aramaMetni.toLowerCase());
  });

  const proSayisi = Object.values(kafeDetaylar).filter(k => k?.plan === 'pro').length;
  const standartSayisi = Object.values(kafeDetaylar).filter(k => k?.plan !== 'pro').length;
  const aktifSayisi = Object.values(kafeDetaylar).filter(k => k?.aktif !== false).length;
  const pasifSayisi = kullanicilar.length - aktifSayisi;
  const uyariSayisi = kullanicilar.filter(u => { const d = abonelikDurumu(u.uid); return d && (d.durum === 'dolmus' || d.durum === 'kritik'); }).length;
  const toplamCiro = Object.values(kafeCirolar).reduce((acc, k) => acc + (k.toplam || 0), 0);
  const toplamSiparis = Object.values(kafeCirolar).reduce((acc, k) => acc + (k.siparisSayisi || 0), 0);

  // Ciro sıralaması
  const ciroSiralamasi = kullanicilar
    .map(u => ({ ...u, kafe: kafeDetaylar[u.uid], ciro: kafeCirolar[u.uid]?.toplam || 0, siparis: kafeCirolar[u.uid]?.siparisSayisi || 0 }))
    .filter(u => u.ciro > 0)
    .sort((a, b) => b.ciro - a.ciro);

  const maxCiro = ciroSiralamasi.length > 0 ? ciroSiralamasi[0].ciro : 1;

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0f172a' }}>
      {/* Header */}
      <div className="sticky top-0 z-10 px-6 py-4 flex justify-between items-center" style={{ backgroundColor: '#0f172a', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold" style={{ background: 'linear-gradient(135deg, #f97316, #ef4444)' }}>👑</div>
          <h1 className="text-white font-bold text-lg">3AMenu SuperAdmin</h1>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={abonelikKontrolEt} className="text-xs px-3 py-2 rounded-lg font-medium" style={{ backgroundColor: 'rgba(249,115,22,0.15)', color: '#f97316', border: '1px solid rgba(249,115,22,0.3)' }}>
            🔄 Abonelik Kontrol
          </button>
          <button onClick={() => signOut(auth)} className="text-xs px-3 py-2 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.6)' }}>Çıkış</button>
        </div>
      </div>

      {/* Kontrol sonucu */}
      {kontrolSonuc && (
        <div className="mx-6 mt-4 rounded-xl p-4 flex justify-between items-center" style={{ backgroundColor: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)' }}>
          <p className="text-sm text-green-400">✅ {kontrolSonuc.kontrolEdildi} hesap kontrol edildi, {kontrolSonuc.pasifYapilan} hesap pasife alındı.</p>
          <button onClick={() => setKontrolSonuc(null)} className="text-green-400 text-lg">✕</button>
        </div>
      )}

      {/* Sekmeler */}
      <div className="flex gap-1 px-6 mt-4 mb-6">
        {[
          { key: 'dashboard', label: '📊 Dashboard' },
          { key: 'kafeler', label: '🏪 Kafeler' },
          { key: 'yeni', label: '➕ Yeni Hesap' },
        ].map(s => (
          <button key={s.key} onClick={() => setAktifSekme(s.key)}
            className="px-4 py-2 rounded-lg text-sm font-medium transition-all"
            style={{ backgroundColor: aktifSekme === s.key ? '#f97316' : 'rgba(255,255,255,0.06)', color: aktifSekme === s.key ? 'white' : 'rgba(255,255,255,0.5)' }}>
            {s.label}
          </button>
        ))}
      </div>

      <div className="px-6 pb-10">

        {/* ── DASHBOARD ── */}
        {aktifSekme === 'dashboard' && (
          <div>
            {/* Üst stat kartları */}
            <div className="grid grid-cols-2 gap-3 mb-6">
              <div className="rounded-2xl p-5" style={{ background: 'linear-gradient(135deg, #1e293b, #0f172a)', border: '1px solid rgba(255,255,255,0.08)' }}>
                <p className="text-xs font-medium mb-1" style={{ color: 'rgba(255,255,255,0.4)' }}>TOPLAM KAFE</p>
                <p className="text-3xl font-bold text-white">{kullanicilar.length}</p>
                <div className="flex gap-3 mt-3">
                  <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: 'rgba(34,197,94,0.15)', color: '#22c55e' }}>✅ {aktifSayisi} Aktif</span>
                  <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: 'rgba(239,68,68,0.15)', color: '#ef4444' }}>🔒 {pasifSayisi} Pasif</span>
                </div>
              </div>
              <div className="rounded-2xl p-5" style={{ background: 'linear-gradient(135deg, #1e293b, #0f172a)', border: '1px solid rgba(255,255,255,0.08)' }}>
                <p className="text-xs font-medium mb-1" style={{ color: 'rgba(255,255,255,0.4)' }}>PLAN DAĞILIMI</p>
                <div className="flex items-end gap-2">
                  <p className="text-3xl font-bold" style={{ color: '#a855f7' }}>{proSayisi}</p>
                  <p className="text-sm mb-1" style={{ color: 'rgba(255,255,255,0.4)' }}>Pro</p>
                </div>
                <div className="flex gap-3 mt-3">
                  <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: 'rgba(168,85,247,0.15)', color: '#a855f7' }}>🚀 {proSayisi} Pro</span>
                  <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: 'rgba(249,115,22,0.15)', color: '#f97316' }}>⭐ {standartSayisi} Standart</span>
                </div>
              </div>
            </div>

            {/* Tahmini MRR */}
            <div className="rounded-2xl p-5 mb-6" style={{ background: 'linear-gradient(135deg, #7c3aed20, #f9731620)', border: '1px solid rgba(249,115,22,0.2)' }}>
              <p className="text-xs font-medium mb-1" style={{ color: 'rgba(255,255,255,0.4)' }}>TAHMİNİ AYLIK GELİR (MRR)</p>
              <p className="text-4xl font-bold text-white">₺{((proSayisi * 1490) + (standartSayisi * 890)).toLocaleString('tr-TR')}</p>
              <p className="text-xs mt-2" style={{ color: 'rgba(255,255,255,0.4)' }}>{proSayisi} × ₺1.490 Pro + {standartSayisi} × ₺890 Standart</p>
              {uyariSayisi > 0 && (
                <div className="mt-3 text-xs px-3 py-2 rounded-lg" style={{ backgroundColor: 'rgba(249,115,22,0.15)', color: '#f97316' }}>
                  ⚠️ {uyariSayisi} kafenin aboneliği dolmuş veya kritik seviyede!
                </div>
              )}
            </div>

            {/* Ciro periyot seçici */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-white font-semibold">Kafe Ciro Raporu</h2>
              <div className="flex gap-1">
                {[{ key: 'bugun', label: 'Bugün' }, { key: 'hafta', label: '7 Gün' }, { key: 'ay', label: 'Bu Ay' }].map(p => (
                  <button key={p.key} onClick={() => setCiroPeriod(p.key)}
                    className="text-xs px-3 py-1.5 rounded-lg transition-all"
                    style={{ backgroundColor: ciroPeriod === p.key ? '#f97316' : 'rgba(255,255,255,0.06)', color: ciroPeriod === p.key ? 'white' : 'rgba(255,255,255,0.4)' }}>
                    {p.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Toplam ciro kartı */}
            <div className="rounded-2xl p-5 mb-4" style={{ background: 'linear-gradient(135deg, #1e293b, #0f172a)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-xs mb-1" style={{ color: 'rgba(255,255,255,0.4)' }}>TÜM KAFELERİN TOPLAM CİROSU</p>
                  {cirolarYukleniyor ? (
                    <p className="text-2xl font-bold text-white">⏳ Yükleniyor...</p>
                  ) : (
                    <p className="text-4xl font-bold text-white">₺{toplamCiro.toLocaleString('tr-TR')}</p>
                  )}
                  <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>{toplamSiparis} sipariş</p>
                </div>
                <div className="text-4xl">💰</div>
              </div>
            </div>

            {/* Kafe ciro sıralaması */}
            {!cirolarYukleniyor && ciroSiralamasi.length > 0 && (
              <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
                <div className="px-4 py-3" style={{ backgroundColor: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                  <p className="text-xs font-medium" style={{ color: 'rgba(255,255,255,0.4)' }}>KAFE CİRO SIRALAMASI</p>
                </div>
                {ciroSiralamasi.map((u, i) => (
                  <div key={u.uid} className="px-4 py-3" style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                    <div className="flex justify-between items-center mb-2">
                      <div className="flex items-center gap-3">
                        <span className="text-lg font-bold" style={{ color: i === 0 ? '#f97316' : i === 1 ? '#94a3b8' : i === 2 ? '#b45309' : 'rgba(255,255,255,0.3)' }}>
                          #{i + 1}
                        </span>
                        <div>
                          <p className="text-sm font-medium text-white">{u.kafe?.ad || u.email}</p>
                          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>{u.siparis} sipariş</p>
                        </div>
                      </div>
                      <p className="font-bold" style={{ color: '#f97316' }}>₺{u.ciro.toLocaleString('tr-TR')}</p>
                    </div>
                    <div className="h-1.5 rounded-full" style={{ backgroundColor: 'rgba(255,255,255,0.06)' }}>
                      <div className="h-full rounded-full transition-all" style={{ width: `${(u.ciro / maxCiro) * 100}%`, background: 'linear-gradient(90deg, #f97316, #ef4444)' }} />
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!cirolarYukleniyor && ciroSiralamasi.length === 0 && (
              <div className="rounded-2xl p-8 text-center" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
                <p className="text-2xl mb-2">📊</p>
                <p className="text-sm" style={{ color: 'rgba(255,255,255,0.3)' }}>Bu dönemde henüz ciro verisi yok</p>
              </div>
            )}
          </div>
        )}

        {/* ── KAFELER ── */}
        {aktifSekme === 'kafeler' && (
          <div>
            <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)}
              placeholder="🔍 Email, kafe adı veya slug ara..."
              className="w-full px-4 py-3 rounded-xl mb-4 text-sm focus:outline-none"
              style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }} />

            <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
              {filtrelenmisKullanicilar.length === 0 ? (
                <div className="p-8 text-center" style={{ color: 'rgba(255,255,255,0.3)' }}>Sonuç bulunamadı</div>
              ) : filtrelenmisKullanicilar.map((u, idx) => {
                const kafe = kafeDetaylar[u.uid];
                const mevcutPlan = kafe?.plan || 'standart';
                const aktif = kafe?.aktif !== false;
                const benimHesabim = u.uid === kullanici.uid;
                const abDurum = abonelikDurumu(u.uid);

                return (
                  <div key={u.uid} className="p-4" style={{ borderBottom: idx < filtrelenmisKullanicilar.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none', opacity: aktif ? 1 : 0.5 }}>
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap mb-1">
                          <p className="font-medium text-white text-sm">{u.email}</p>
                          {benimHesabim && <span className="text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(59,130,246,0.15)', color: '#60a5fa' }}>Ben</span>}
                          <span className="text-xs px-2 py-0.5 rounded-full font-semibold" style={{ backgroundColor: mevcutPlan === 'pro' ? 'rgba(168,85,247,0.15)' : 'rgba(249,115,22,0.15)', color: mevcutPlan === 'pro' ? '#a855f7' : '#f97316' }}>
                            {mevcutPlan === 'pro' ? '🚀 Pro' : '⭐ Standart'}
                          </span>
                          <span className="text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: aktif ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)', color: aktif ? '#22c55e' : '#ef4444' }}>
                            {aktif ? '✅ Aktif' : '🔒 Pasif'}
                          </span>
                        </div>
                        {kafe?.ad ? (
                          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>🏪 {kafe.ad}{kafe.slug && ` — /${kafe.slug}`}</p>
                        ) : (
                          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>⚠️ Kurulum yapılmamış</p>
                        )}
                        {kafe?.abonelikBitis && (
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>📅 {kafe.abonelikBitis}</span>
                            {abDurum && <span className="text-xs px-2 py-0.5 rounded-full font-semibold" style={{ backgroundColor: abDurum.renk + '20', color: abDurum.renk }}>{abDurum.label}</span>}
                          </div>
                        )}
                        {kafeCirolar[u.uid]?.toplam > 0 && (
                          <p className="text-xs mt-1" style={{ color: '#f97316' }}>💰 ₺{kafeCirolar[u.uid].toplam.toLocaleString('tr-TR')} ciro</p>
                        )}
                      </div>
                      {!benimHesabim && (
                        <button onClick={() => kullaniciyiSil(u.uid)} className="text-xs px-2 py-1 rounded-lg ml-2" style={{ backgroundColor: 'rgba(239,68,68,0.15)', color: '#ef4444' }}>🗑️</button>
                      )}
                    </div>

                    <div className="flex gap-2 flex-wrap">
                      {kafe?.slug && (
                        <a href={`${SITE_URL}/menu/${kafe.slug}/1`} target="_blank" rel="noreferrer"
                          className="text-xs px-3 py-1.5 rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.5)' }}>👁️ Menü</a>
                      )}
                      <button onClick={() => planGuncelle(u.uid, 'standart')}
                        className="text-xs px-3 py-1.5 rounded-lg font-medium transition-all"
                        style={{ backgroundColor: mevcutPlan === 'standart' ? '#f97316' : 'rgba(255,255,255,0.06)', color: mevcutPlan === 'standart' ? 'white' : 'rgba(255,255,255,0.4)' }}>
                        ⭐ Standart
                      </button>
                      <button onClick={() => planGuncelle(u.uid, 'pro')}
                        className="text-xs px-3 py-1.5 rounded-lg font-medium transition-all"
                        style={{ backgroundColor: mevcutPlan === 'pro' ? '#a855f7' : 'rgba(255,255,255,0.06)', color: mevcutPlan === 'pro' ? 'white' : 'rgba(255,255,255,0.4)' }}>
                        🚀 Pro
                      </button>
                      {!benimHesabim && (
                        <button onClick={() => aktifToggle(u.uid, aktif)}
                          className="text-xs px-3 py-1.5 rounded-lg font-medium"
                          style={{ backgroundColor: aktif ? 'rgba(239,68,68,0.15)' : 'rgba(34,197,94,0.15)', color: aktif ? '#ef4444' : '#22c55e' }}>
                          {aktif ? '🔒 Pasife Al' : '✅ Aktif Et'}
                        </button>
                      )}
                      {!benimHesabim && (
                        <button onClick={() => { setAbonelikModal({ uid: u.uid, email: u.email, mevcutTarih: kafe?.abonelikBitis }); setAbonelikTarih(kafe?.abonelikBitis || ''); }}
                          className="text-xs px-3 py-1.5 rounded-lg"
                          style={{ backgroundColor: 'rgba(59,130,246,0.15)', color: '#60a5fa' }}>
                          📅 Abonelik
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ── YENİ HESAP ── */}
        {aktifSekme === 'yeni' && (
          <div className="rounded-2xl p-5" style={{ border: '1px solid rgba(255,255,255,0.08)', backgroundColor: 'rgba(255,255,255,0.02)' }}>
            <h2 className="font-semibold text-white mb-4">➕ Yeni Kafe Hesabı</h2>
            <input value={yeniEmail} onChange={e => setYeniEmail(e.target.value)} placeholder="Email" type="email"
              className="w-full px-4 py-3 rounded-xl mb-3 text-sm focus:outline-none"
              style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }} />
            <div className="relative mb-3">
              <input value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} placeholder="Şifre"
                type={sifreGoster ? 'text' : 'password'}
                className="w-full px-4 py-3 rounded-xl text-sm focus:outline-none"
                style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }} />
              <button onClick={() => setSifreGoster(!sifreGoster)} className="absolute right-3 top-3 text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>{sifreGoster ? '🙈' : '👁️'}</button>
            </div>
            <select value={yeniPlan} onChange={e => setYeniPlan(e.target.value)}
              className="w-full px-4 py-3 rounded-xl mb-4 text-sm focus:outline-none"
              style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }}>
              <option value="standart">⭐ Standart — 890₺/ay</option>
              <option value="pro">🚀 Pro — 1.490₺/ay</option>
            </select>
            <button onClick={yeniKullaniciolustur} disabled={yukleniyor}
              className="w-full py-3 rounded-xl font-semibold disabled:opacity-50"
              style={{ background: 'linear-gradient(135deg, #f97316, #ef4444)', color: 'white' }}>
              {yukleniyor ? '⏳ Oluşturuluyor...' : 'Hesap Oluştur'}
            </button>
          </div>
        )}
      </div>

      {/* Abonelik modal */}
      {abonelikModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
          onClick={e => { if (e.target === e.currentTarget) setAbonelikModal(null); }}>
          <div className="rounded-2xl w-full max-w-sm p-6" style={{ backgroundColor: '#1e293b', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h2 className="text-lg font-bold text-white mb-1">📅 Abonelik Tarihi</h2>
            <p className="text-sm mb-4" style={{ color: 'rgba(255,255,255,0.4)' }}>{abonelikModal.email}</p>
            <input type="date" value={abonelikTarih} onChange={e => setAbonelikTarih(e.target.value)}
              className="w-full px-4 py-3 rounded-xl mb-3 text-sm focus:outline-none"
              style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }} />
            <div className="flex gap-2 mb-4 flex-wrap">
              {[{ label: '1 Ay', ay: 1 }, { label: '3 Ay', ay: 3 }, { label: '6 Ay', ay: 6 }, { label: '1 Yıl', ay: 12 }].map(({ label, ay }) => (
                <button key={ay} onClick={() => {
                  const d = new Date(); d.setMonth(d.getMonth() + ay);
                  setAbonelikTarih(d.toISOString().split('T')[0]);
                }} className="text-xs px-3 py-1.5 rounded-lg" style={{ backgroundColor: 'rgba(249,115,22,0.15)', color: '#f97316' }}>
                  +{label}
                </button>
              ))}
            </div>
            {abonelikTarih && (
              <div className="rounded-xl p-3 mb-4 text-xs" style={{ backgroundColor: 'rgba(59,130,246,0.1)', color: '#60a5fa' }}>
                Abonelik <strong>{abonelikTarih}</strong> tarihine kadar aktif olacak.
              </div>
            )}
            <div className="flex gap-3">
              <button onClick={() => setAbonelikModal(null)} className="flex-1 py-3 rounded-xl font-semibold text-sm" style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.6)' }}>İptal</button>
              <button onClick={abonelikKaydet} className="flex-1 py-3 rounded-xl font-semibold text-sm" style={{ background: 'linear-gradient(135deg, #f97316, #ef4444)', color: 'white' }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SuperAdmin;